import React from "react";
import ReactApexChart from "react-apexcharts";

const SecurityAuditGraph = ({ report }) => {

  const getColorByValue = (score) => {
    if (score <= 20) return "#dc3545";
    if (score <= 40) return "#ffc107b5";
    if (score <= 60) return "#ffc107";
    if (score <= 80) return "#fd7e14";
    return "#198754";
  };

  const getLabelByValue = (val) => {
    if (val <= 20) return "Compromised";
    if (val <= 40) return "Weak";
    if (val <= 60) return "Bellow Average";
    if (val <= 80) return "Average";
    return "Strong";
  };

  const baseColor = getColorByValue(report);

  const series = [report];

  const options = {
    chart: {
      type: "radialBar",
      offsetY: -20,
      sparkline: { enabled: true },
    },
    colors: [baseColor],
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        dataLabels: {
          name: {
            show: true,
            offsetY: 0,
            fontSize: "14px",
            color: baseColor,
            formatter: () => getLabelByValue(report),
          },
          value: {
            offsetY: -45,
            fontSize: "14px",
            color: baseColor,
            formatter: (val) => `${Math.round(val)}%`,
          },
        },
      },
    },
    fill: { type: "solid" },
    labels: ["Status"],
  };

  return <ReactApexChart options={options} series={series} type="radialBar" />;
};

export default SecurityAuditGraph;
